module.exports = __webpack_public_path__ + "static/media/ingredient_insights.2d71c2c9.png";